export default __webpack_public_path__ + "static/media/product-super.944e8303.jpg";